import React, { useMemo } from "react";
import {
  have_product_reference,
  isOrderRowCod,
} from "../../../../../helpers/OrdersFunctionsGlobal";
import { returnEuroString } from "../../../../../helpers/Utils";
import { LongButton } from "../../../Buttons";
import DeliveryBlockChange from "./delivery_block_change";
import { useDispatch, useSelector } from "react-redux";
import { getParcelTerminal } from "../../../../../redux/Actions/parcelTerminalAction";

function DeliveryComponent({
  order_rows,
  delivery_add_col,
  carrier,
  orderId,
  total_shipping,
  payment,
  shipping_address,
  updateShippingAddress,
  order_shop_id,
  cod,
  nordrent,
}) {
  const dispatch = useDispatch();
  const { parcel_terminals } = useSelector((state) => state.options);

  const order_row_cod = useMemo(() => {
    if (order_rows && Array.isArray(order_rows)) {
      return order_rows.find((order_row) => {
        if (
          !have_product_reference(order_row.product_reference) &&
          isOrderRowCod(order_row.id_product, order_shop_id)
        ) {
          return true;
        }
        return false;
      })?.unit_price_tax_incl;
    }
  }, [order_rows]);

  const parcelTerminalName = useMemo(() => {
    console.log("parcelTerminalName");
    if (!shipping_address?.parcel_terminal_id) return null;
    return dispatch(getParcelTerminal(shipping_address?.parcel_terminal_id))
      ?.label;
  }, [shipping_address?.parcel_terminal_id, parcel_terminals]);

  return (
    <div className="bg-silver col-12 py-3">
      <div className="d-flex justify-content-center align-item-center mb-2">
        <LongButton
          text={`Delivery price: ${returnEuroString(
            cod && order_row_cod
              ? +order_row_cod + +total_shipping
              : total_shipping
          )}`}
        />
      </div>
      <div className="text-black">
        {carrier.identifier == "store" ? (
          <span>
            {carrier.name}
            {cod && order_row_cod && (
              <span className="text-warning pl-2">({order_row_cod})</span>
            )}
          </span>
        ) : (
          <React.Fragment>
            <div>
              Delivery method:
              {carrier.name}
              {cod && order_row_cod && (
                <span className="text-warning pl-2">({order_row_cod})</span>
              )}
            </div>
            {!!parcelTerminalName && (
              <div>
                Post machine:
                {parcelTerminalName}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      {/* Nordrent: hide "Payment:" line */}
      {!nordrent && (
        <div>
          Payment: <span>{payment}</span>
        </div>
      )}
      {delivery_add_col && (
        <React.Fragment>
          <hr />
          <DeliveryBlockChange
            shipping_address={shipping_address}
            orderId={orderId}
            carrier={carrier}
            updateShippingAddress={updateShippingAddress}
            total_shipping={total_shipping}
            payment={payment}
            order_shop_id={order_shop_id}
          />
        </React.Fragment>
      )}
    </div>
  );
}

export default DeliveryComponent;
